import { render, staticRenderFns } from "./RegisteredOpportunity.vue?vue&type=template&id=c1475fda&"
import script from "./RegisteredOpportunity.vue?vue&type=script&lang=js&"
export * from "./RegisteredOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredOpportunity.vue?vue&type=style&index=0&id=c1475fda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports